import { EContentOfPairedStackContainer, PairedStackContainer, } from "@tedivo/tedivo-bay-grid-pure";
import { sortNumericAsc } from "@tedivo/tedivo-pure-helpers";
export function getContainersByMaxSizePerStack(smartBay) {
    var _a;
    const [fwdBay] = smartBay.tBaysStr.split("-");
    const tiersContent = new Map();
    const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();
    for (const tierKey of allTiersKeys) {
        for (const stackKey of allStacksKeys.sort(sortNumericAsc)) {
            const currContent = (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[tierKey];
            if (!currContent || currContent.maxSize === undefined)
                continue;
            const prevContent = tiersContent.get(tierKey);
            if (!prevContent) {
                /** If the tier is not in the map, add it */
                tiersContent.set(tierKey, currContent);
                continue;
            }
            else {
                /** If the smartTier has already a 40x, continue */
                if (prevContent.content === EContentOfPairedStackContainer.ONE40 &&
                    prevContent.maxSize >= currContent.maxSize)
                    continue;
                /** If the previous content is the same as the current content,
                 * and the previous max size is greater than the current max size, continue */
                if (prevContent.content === currContent.content) {
                    if (prevContent.maxSize >= currContent.maxSize)
                        continue;
                }
                // Add it following the rules:
                // It can be ONE40, ONE20_FWD, ONE20_AFT or TWO20.
                switch (currContent.content) {
                    case EContentOfPairedStackContainer.ONE40:
                        // If it is ONE40 here, it has a bigger size than the previous one (initial if), so we add it
                        tiersContent.set(tierKey, currContent);
                        break;
                    case EContentOfPairedStackContainer.TWO20:
                        // If it is TWO20 here, means a whole block of 20ft containers,
                        // The previous content can only be ONE20_FWD or ONE20_AFT or smaller TWO20, so we add it
                        tiersContent.set(tierKey, currContent);
                        break;
                    case EContentOfPairedStackContainer.ONE20_FWD:
                        // If it is ONE20_FWD here, check if the previous was the same and smaller
                        if (prevContent.content === currContent.content &&
                            prevContent.maxSize <= currContent.maxSize) {
                            tiersContent.set(tierKey, currContent);
                        }
                        else if (prevContent.content === EContentOfPairedStackContainer.ONE20_AFT) {
                            // If the previous was ONE20_AFT, we need to create a new PairedStackContainer with the two 20s
                            const newContent = new PairedStackContainer(tierKey, Number(fwdBay));
                            newContent.addContainer(currContent.containers[0]);
                            newContent.addContainer(prevContent.containers[0]);
                            tiersContent.set(tierKey, newContent);
                        }
                        break;
                    case EContentOfPairedStackContainer.ONE20_AFT:
                        if (prevContent.content === currContent.content &&
                            prevContent.maxSize <= currContent.maxSize) {
                            tiersContent.set(tierKey, currContent);
                        }
                        else if (prevContent.content === EContentOfPairedStackContainer.ONE20_FWD) {
                            // If the previous was ONE20_FWD, we need to create a new PairedStackContainer with the two 20s
                            const newContent = new PairedStackContainer(tierKey, Number(fwdBay));
                            newContent.addContainer(currContent.containers[0]);
                            newContent.addContainer(prevContent.containers[0]);
                            tiersContent.set(tierKey, newContent);
                        }
                        break;
                }
            }
        }
    }
    const containers = [];
    tiersContent.forEach((tc) => {
        if (tc)
            containers.push(...tc.containers);
    });
    return {
        containers,
        tBaysStr: smartBay.tBaysStr,
        level: smartBay.level,
    };
}
